export function useSessionStorage() {
    function setIsEnTab(val) {
        sessionStorage.setItem('isEnTab', String(val ?? 'false'));
    }
    function getIsEnTab() {
        return sessionStorage.getItem('isEnTab') === 'true';
    }
    return {
        setIsEnTab,
        getIsEnTab,
    };
}
